import TrackingService from '@/services/tracking';
import { theme } from '@/styles';
import { UrlObject } from '@/types';
import Image from '@/ui/Image';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Close48Icon from '../Icons/Close48Icon';
import SlideList from '@/components/SlideList';

export interface DetailImgProps {
  isOpen: boolean;
  onClose: (e: boolean) => void;
  data?: UrlObject[];
  currentData?: UrlObject;
}

const DetailImg = (props: DetailImgProps) => {
  const [currentImg, setCurrentImg] = useState<UrlObject | undefined>(
    props.currentData,
  );
  useEffect(() => {
    setCurrentImg(props.currentData);
    if (!props.isOpen) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [props.isOpen, props]);

  return (
    <>
      {currentImg && (
        <DimmedBox isOpen={props.isOpen} {...TrackingService.tagGTM('gallery')}>
          <DetailImgContainer>
            <DetailImgCloseBtn
              onClick={() => props.onClose(false)}
              {...TrackingService.tagGTM('gallery_close_button')}
            >
              <Close48Icon fill={theme.colors.neutral_colors.white} />
            </DetailImgCloseBtn>
            <DetailImgMain>
              <Image
                src={`http:${currentImg.url}`}
                // layout={'fixed'}
                width="870px"
                height="528px"
                objectFit={'contain'}
                alt={'currentImg'}
                // objectPosition={'center'}
                style={{ borderRadius: '2px' }}
              />
            </DetailImgMain>
            <SlideList
              baseWidth={870}
              itemWidth={72}
              itemHeight={72}
              gap={8}
              columnCount={11}
              data={props.data || []}
              hasArrow={true}
              top={16}
            >
              {({ item, width, height }) => (
                <DetailImgListItem
                  onClick={() => setCurrentImg(item)}
                  state={item.url === currentImg?.url}
                  {...TrackingService.tagGTM('gallery_images_button')}
                >
                  <Image
                    src={`http:${item.url}`}
                    width={width}
                    height={height}
                    alt={'detail_img'}
                    objectFit={'cover'}
                    // layout="fixed"
                  />
                </DetailImgListItem>
              )}
            </SlideList>
          </DetailImgContainer>
        </DimmedBox>
      )}
    </>
  );
};

export default DetailImg;

const DimmedBox = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
  position: fixed;
  z-index: 999;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.accent_colors.dimmed[4]};
`;

const DetailImgContainer = styled.div`
  width: 870px;
  height: 700px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const DetailImgCloseBtn = styled.div`
  align-self: flex-end;
  margin-bottom: 20px;
  cursor: pointer;
`;

const DetailImgMain = styled.div`
  width: 870px;
  height: 528px;
  margin-bottom: 32px;
`;

const DetailImgListItem = styled.div<{ state: boolean }>`
  border-radius: 2px;
  width: 72px;
  height: 72px;
  cursor: pointer;
  box-sizing: border-box;
  border: ${({ state }) =>
    state
      ? `2px solid ${theme.colors.accent_colors.blue.default}`
      : `2px solid transparent`};
  overflow: hidden;
`;
